import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
// import './LandingPage.css';
import CuisineCard from '../components/CuisineCard';
import CuisineCardsSelector from '../components/CuisineCardsSelector';
import SampleMealPlan from '../components/SampleMealPlan';
import SampleGroceryList from '../components/SampleGroceryList';
import { useAuth } from '../context/AuthContext';
import styles from './LandingPage.module.css';

const LandingPage = () => {
    const [cuisines, setCuisines] = useState([{ id: 1, name: 'Italian' }, { id: 2, name: 'Mexican' }, { id: 3, name: 'Indian' }, { id: 4, name: 'Japanese' }, { id: 5, name: 'Korean' }, { id: 6, name: 'Thai' }, { id: 7, name: 'Chinese' }, { id: 8, name: 'French' }, { id: 9, name: 'Spanish' }, { id: 10, name: 'Mediterranean' }]);
    const { user, pgUser } = useAuth();
    const navigate = useNavigate();

    // Redirect logged-in users to appropriate page based on their status
    useEffect(() => {
        if (user) {
            // If user exists but pgUser is not loaded yet, wait
            if (pgUser === null || pgUser === undefined) {
                return; // Wait for pgUser to load
            }
            
            // Check email confirmation first
            if (!pgUser.email_confirmed) {
                navigate('/email-confirmation');
                return;
            }
            
            // Check if setup is complete
            if (!pgUser.setup_complete) {
                navigate('/setup');
                return;
            }
            
            // User is confirmed and setup is complete, go to meal plan
            navigate('/meal-plan');
        }
    }, [user, pgUser, navigate]);


    return (
        <div className="landing-page">
            {/* Add company logo and name */}
            <div className="landing-header">
                <Link to="/" className="landing-brand">
                    <img src="/icons/autochef_logo.svg" alt="AutoChef" className="company-logo" />
                    <span className="company-name d-lg-inline">AutoChef</span>
                </Link>
                {!user && (
                    <div className="landing-auth">
                        <Link to="/login" className="landing-auth-link">Log in</Link>
                        <Link to="/signup" className="landing-auth-link landing-auth-signup">Sign up</Link>
                    </div>
                )}
            </div>

            <div className="hero-section">
            <img 
                src="/images/landingPageImage.jpg" 
                alt="Hero" 
                className="hero-image"
            />
            <div className="hero-content">
                <section className="headline">
                    <h1>Your meals on autopilot.</h1>
                    <div className="benefits">
                        
                        {/* <h4>Stress <strong>less.</strong></h4> */}
                        <h4>Cook <strong>more</strong>.</h4>
                        <h4>Spend <strong>less.</strong></h4>
                    </div>
                </section>
                <section className="cta">
                    {/* <h2>Get Started</h2> */}
                    <Link to={user ? "/recipes" : "/signup"}>
                        <button className="cta-button">
                            {user ? "View Recipes" : "Create Meal Plan"}
                        </button>
                    </Link>
                </section>
            </div>
        </div>
            <header className="header">
                {/* <h1>Welcome to AutoChef</h1> */}
                {/* <p>Your personal meal planning assistant</p> */}
            </header>
            <main className={styles['main-content']}>
                {/* Problem Statement Section */}
                <section className={styles['problem-statement']}>
                    <h4>It's time to leave meal kit delivery behind.</h4>
                    <div className={styles['steps']}>
                        <div className={styles['step']}>
                            <h3 style={{color: '#52cd92'}}>Cheaper</h3>
                            <p>Don’t overpay for groceries you could buy yourself. AutoChef helps you shop smarter and spend less.</p>
                        </div>
                        <div className={styles['step']}>
                            <h3 style={{color: '#52cd92'}}>Fresher</h3>
                            <p>Enjoy ingredients straight from your local store — fresher than boxes shipped across the country.</p>
                        </div>
                        
                        <div className={styles['step']}>
                            <h3 style={{color: '#52cd92'}}>Easier</h3>
                            <p>Skip the waste, skip the stress. Cook more with less effort and zero guesswork.</p>
                        </div>
                        
                    </div>
                </section>

                {/* Solution Overview Section */}
                <section className={styles['solution-overview']}>
                    <h2>Your Kitchen, Your Control</h2>
                    <div className={styles.benefits}>
                        <div className={styles.benefit}>
                            <h3>500+ Recipes</h3>
                            <p>Endless possibilities to explore new flavors and cuisines.</p>
                        </div>
                        <div className={styles.benefit}>
                            <h3>Smart Planning</h3>
                            <p>Automatic meal suggestions based on your preferences and what you already have in your pantry.</p>
                        </div>
                        <div className={styles.benefit}>
                            <h3>Shop Your Way</h3>
                            <p>Buy ingredients where and when you want.</p>
                        </div>
                    </div>
                </section>

                {/* How It Works Section */}
                <section className={styles['how-it-works']}>
                    <h2>A Better Way to Meal Plan</h2>
                    <div className={styles.steps}>
                    <div className={styles.step}>
                        <div className={styles['step-number']}>1</div>
                        <h3>Set Your Preferences</h3>
                        <p>Tell us about your tastes, dietary needs, and cooking style.</p>
                    </div>
                    <div className={styles.step}>
                        <div className={styles['step-number']}>2</div>
                        <h3>Get Your Plan & List</h3>
                        <p>Receive weekly meal suggestions with smart grocery lists and pantry tracking.</p>
                    </div>
                    <div className={styles.step}>
                        <div className={styles['step-number']}>3</div>
                        <h3>Start Cooking</h3>
                        <p>Follow step-by-step instructions and enjoy stress-free meals.</p>
                    </div>
                    </div>

                </section>

                {/* Cuisine Variety Section */}
                <section className={styles['cuisine-variety']}>
                    <h2>Explore Global Flavors</h2>
                    <p>From Italian classics to Asian fusion, discover recipes from around the world that match your taste preferences.</p>
                    <div className={styles['cuisine-cards-container']}>
                        {cuisines.map(cuisine => (
                            <div key={cuisine.id} className="diet-card">
                                <img 
                                    className="diet-card-image"
                                    src={`/images/cuisineImages/${cuisine.name.toLowerCase()}.jpg`} 
                                    alt={cuisine.name} 
                                />
                                <div className="diet-card-content">
                                    <h3 className="recipe-filter-name">{cuisine.name}</h3>
                                </div>
                            </div>
                        ))}
                    </div>
                </section>

                {/* Social Proof Section */}
                {/* <section className={styles['social-proof']}>
                    <h2>Join the AutoChef Community</h2>
                    <div className={styles.stats}>
                        <div className={styles.stat}>
                            <div className={styles['stat-number']}>500+</div>
                            <div className={styles['stat-label']}>Curated Recipes</div>
                        </div>
                        <div className={styles.stat}>
                            <div className={styles['stat-number']}>30+</div>
                            <div className={styles['stat-label']}>Global Cuisines</div>
                        </div>
                        <div className={styles.stat}>
                            <div className={styles['stat-number']}>4.8★</div>
                            <div className={styles['stat-label']}>User Rating</div>
                        </div>
                    </div>
                </section> */}
            </main>
            {/* <footer className={styles.footer}>
                <div className={styles['footer-content']}>
                    <div className={styles['footer-section']}>
                        <h4>About</h4>
                        <ul className={styles['footer-links']}>
                            <li><Link to="/about">About Us</Link></li>
                            <li><Link to="/careers">Careers</Link></li>
                            <li><Link to="/press">Press</Link></li>
                            <li><Link to="/blog">Blog</Link></li>
                        </ul>
                    </div>
                    
                    <div className={styles['footer-section']}>
                        <h4>Help</h4>
                        <ul className={styles['footer-links']}>
                            <li><Link to="/faq">FAQ</Link></li>
                            <li><Link to="/support">Support Center</Link></li>
                            <li><Link to="/contact">Contact Us</Link></li>
                            <li><Link to="/feedback">Send Feedback</Link></li>
                        </ul>
                    </div>

                    <div className={styles['footer-section']}>
                        <h4>Legal</h4>
                        <ul className={styles['footer-links']}>
                            <li><Link to="/terms">Terms of Service</Link></li>
                            <li><Link to="/privacy">Privacy Policy</Link></li>
                            <li><Link to="/cookies">Cookie Policy</Link></li>
                            <li><Link to="/security">Security</Link></li>
                        </ul>
                    </div>

                    <div className={styles['footer-section']}>
                        <h4>Features</h4>
                        <ul className={styles['footer-links']}>
                            <li><Link to="/meal-planning">Meal Planning</Link></li>
                            <li><Link to="/grocery-lists">Grocery Lists</Link></li>
                            <li><Link to="/pantry">Pantry Management</Link></li>
                            <li><Link to="/recipes">Recipe Collection</Link></li>
                        </ul>
                    </div>
                </div>
                
                <div className={styles['footer-bottom']}>
                    <p>© {new Date().getFullYear()} AutoChef. All rights reserved.</p>
                </div>
            </footer> */}
        </div>
    );
};

export default LandingPage;
